<template>
  <v-card class="pa-4 my-4">
    <v-text-field label="Base URL" v-model="baseUrl" :hint="'Full url: '  + baseUrl + '/make/model'  "></v-text-field>
  </v-card>
</template>

<script setup lang="ts">
import { useSettingsStore } from '@/stores/settings'
import { ref, onMounted, watch } from 'vue'

const props = defineProps<{
  selectedPlacement: string
}>()
const settingsStore = useSettingsStore()

const baseUrl = ref('')

onMounted(() => {
  if (
    settingsStore.placements.placements &&
    settingsStore.placements.placements[props.selectedPlacement] &&
    settingsStore.placements.placements[props.selectedPlacement].baseUrl &&
    settingsStore.placements.placements[props.selectedPlacement].baseUrl.length > 0
  ) {
    baseUrl.value =
      settingsStore.placements.placements[props.selectedPlacement].baseUrl
  }
})

watch(
  () => baseUrl.value,
  () => {
    settingsStore.placements.placements[props.selectedPlacement].baseUrl =
      baseUrl.value
  },
)
</script>
